import api from 'api'
import { path } from 'ramda'
import { User } from 'api/typings'

export async function searchUsers(keyword: string) {
  const result = await api.post<{ data: { admin: { users: User[] } } }>(
    '/admin/graphql_dispatch/admin_user_search_d9c10961',
    {
      searchTerm: keyword,
    }
  )
  return path(['data', 'data', 'admin', 'users'], result) as User[]
}
